"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.withFormTracking = exports.withClickTracking = exports.overwriteDisplayName = void 0;

var _clickTracking = _interopRequireDefault(require("./tracking/clickTracking"));

exports.withClickTracking = _clickTracking["default"];

var _formTracking = _interopRequireDefault(require("./tracking/formTracking"));

exports.withFormTracking = _formTracking["default"];

var _setWrappedDisplayName = require("./tracking/setWrappedDisplayName");

exports.overwriteDisplayName = _setWrappedDisplayName.overwriteDisplayName;